var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: ["replies_outer", _vm.depth === 0 ? "indent" : ""],
      attrs: { "data-depth": _vm.depth },
    },
    [
      _c("div", { staticClass: "c-comments__comment" }, [
        _c("img", {
          staticClass: "c-comments__img",
          attrs: {
            src: _vm.reply.user_avatar,
            alt: _vm.reply.user_name + " comment",
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "c-comments__content" }, [
          _c("div", { staticClass: "c-comments__user" }, [
            _c("p", [
              _c("a", { attrs: { href: "/u/" + _vm.reply.user_name } }, [
                _vm._v(_vm._s(_vm.reply.user_name)),
              ]),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(
                  _vm.parent_username ? _vm.parent_username : _vm.first_username
                )
              ),
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.reply.comment_created))]),
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "u-m-t1 u-m-b3 c-comments__text",
              domProps: { innerHTML: _vm._s(_vm.reply.comment_text) },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.reply.comment_text) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _vm.reply.comment_image != ""
            ? _c("p", { staticClass: "u-m-t1 u-m-b3" }, [
                _c("img", {
                  attrs: {
                    src: _vm.reply.comment_image,
                    alt: _vm.reply.user_name + "comment",
                  },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "c-comments__cta" }, [
            _c("p", [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.commentReply.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("Reply")]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                on: {
                  click: function ($event) {
                    return _vm.saveCommentLike(_vm.reply.comment_id)
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    class: { liked: _vm.userLiked > 0 },
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "17",
                      height: "16",
                      viewBox: "0 0 17 16",
                    },
                  },
                  [
                    _c("defs", [
                      _c("path", {
                        attrs: {
                          id: "icon-likes-a",
                          d: "M17,5.18420563 C17,2.3210388 14.6586159,0 11.7703517,0 C10.5319425,0 9.39596622,0.428901458 8.5,1.14203776 C7.60403378,0.428901458 6.46805748,0 5.2296483,0 C2.34138409,0 0,2.3210388 0,5.18420563 C0,6.53676412 0.526736417,7.76419979 1.38241523,8.68721952 L7.21466028,15.4226081 C7.2502332,15.4684936 7.28794907,15.5126796 7.32866507,15.5541039 C7.60574814,15.8321782 7.98012101,16 8.39413841,16 C8.8081558,16 9.18252868,15.8321782 9.45232573,15.5617515 C9.49925627,15.5122547 9.52582882,15.4831514 9.5509013,15.4525611 L15.6250851,8.68721952 C16.4732636,7.76419979 17,6.53676412 17,5.18420563 Z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "g",
                      {
                        staticClass: "like",
                        attrs: { fill: "none", "fill-rule": "evenodd" },
                      },
                      [
                        _c("path", {
                          attrs: {
                            stroke: "#888",
                            d: "M16.5,5.18420563 C16.5,2.59816271 14.3834456,0.5 11.7703517,0.5 C10.6797153,0.5 9.64690314,0.868217049 8.81137834,1.53324554 L8.5,1.78108435 L8.18862166,1.53324554 C7.35309686,0.868217049 6.32028473,0.5 5.2296483,0.5 C2.61655436,0.5 0.5,2.59816271 0.5,5.18420563 C0.5,6.37005443 0.95018776,7.48551872 1.76040116,8.35991746 L7.609819,15.1162593 C7.63588257,15.1498787 7.6608115,15.1787446 7.68284916,15.2011824 C7.87441495,15.3934335 8.1244312,15.5 8.39413841,15.5 C8.66292177,15.5 8.91335152,15.3940512 9.08949156,15.2177292 C9.13138797,15.1735418 9.14959901,15.1534179 9.17885461,15.1185233 L15.256921,8.34890727 C16.0511659,7.48458011 16.5,6.36808352 16.5,5.18420563 Z",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.commentLikes == 1
                  ? _c("p", [_vm._v(_vm._s(_vm.commentLikes) + " Like")])
                  : _vm.commentLikes > 1
                  ? _c("p", [_vm._v(_vm._s(_vm.commentLikes) + " Likes")])
                  : _c("p", [_vm._v("Like")]),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.showReplyBox
        ? _c(
            "div",
            [
              _c("comment-box", {
                attrs: { "parent-id": _vm.reply.comment_id },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.reply.replies, function (deepReply) {
        return _c("deep-replies", {
          key: deepReply.comment_id,
          attrs: {
            reply: deepReply,
            first_username: deepReply.user_name,
            depth: _vm.currentDepth,
          },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }